import { LeadMasterData } from "types/models/leadMaster/LeadMasterApp";

export const GET_LEAD = "GET_LEAD";
export const SET_LEAD_DATA = "SET_LEAD_DATA";
export const CREATE_LEAD = "CREATE_LEAD";
export const RESET_LEAD_DATA = "RESET_LEAD_DATA";

export const UPDATE_LEAD= "UPDATE_LEAD";

export interface GetLeadAction {
  type: typeof GET_LEAD;
  payload: { data: LeadMasterData[]; total: number };
}

export interface SetLeadDetailAction {
  type: typeof SET_LEAD_DATA;
  payload: LeadMasterData;
}
export interface createLead{
  type: typeof CREATE_LEAD;
    payload: any; 
}
export interface updateLead{
  type: typeof UPDATE_LEAD;
    payload: any; 
}
export interface ResetLead{
  type: typeof RESET_LEAD_DATA;
}

export type LeadMasterActionTypes =
  | GetLeadAction
  | SetLeadDetailAction
  | createLead
  |updateLead
  |ResetLead
